import { usePreSelectedResourceStore } from "@/pages/taskpane/shared/stores/preSelectedResourceStore";
import { EPreSelectedResource } from "@/pages/taskpane/shared/types/enums/preSelectedResourceEnum";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";
import React from "react";
import AlternativeResource from "./AlternativeResource";
import OpenOrderForm from "./OpenOrderForm";
import RemovedResource from "./RemovedResource";
import SlideUpPanel from "@/pages/taskpane/components/ui/SlideUpPanel";
import HStack from "@/pages/taskpane/components/layout/HStack";
import Button from "@/pages/taskpane/components/ui/Button";
import { useThemeStore } from "@/pages/taskpane/shared/stores";
import { ArrowLeftRegular } from "@/pages/taskpane/components/icons/IconCustom";
import MeetingType from "./MeetingType";
import MoveOrder from "./MoveOrder";

const PreSelectedResource = () => {
  const { isProcessingAlternativeResource, items } = usePreSelectedResourceStore();
  const { isDarkMode } = useThemeStore();

  const renderItem = (item: PreSelectedResourceInfo) => {
    switch (item.type) {
      case EPreSelectedResource.ConflictOccurrence:
        return <AlternativeResource key={item.id} notifyInfo={item} />;
      case EPreSelectedResource.OpenOderForm:
        return <OpenOrderForm key={item.id} notifyInfo={item} />;
      case EPreSelectedResource.Removed:
        return <RemovedResource key={item.id} notifyInfo={item} />;
      case EPreSelectedResource.MeetingType:
        return <MeetingType key={item.id} notifyInfo={item} />;
      case EPreSelectedResource.MoveOrder:
        return <MoveOrder key={item.id} notifyInfo={item} />;
      default:
        return null;
    }
  };

  const renderContent = () => {
    if (isProcessingAlternativeResource) {
      return <AlternativeResource />;
    }
    return (
      <div className="px-5 py-4 no-scrollbar flex flex-col gap-4 [&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-gray-200 [&>*:not(:last-child)]:pb-4">
        {items?.map((item) => renderItem(item))}
      </div>
    );
  };

  const onRenderHeader = () => {
    return (
      <HStack className="w-full px-5 py-4 border-b border-lightGray dark:border-darkMediumGray">
        <Button leftIcon={<ArrowLeftRegular isDarkMode={isDarkMode} />} />
      </HStack>
    );
  };

  return items && items.length > 0 ? (
    <SlideUpPanel
      isOpen={true}
      title={!isProcessingAlternativeResource ? "Warning" : ""}
      children={renderContent()}
      onRenderHeader={isProcessingAlternativeResource ? onRenderHeader : undefined}
      hideCloseButton={true}
    />
  ) : null;
};

export default PreSelectedResource;
